
import { BaseActionEnum } from "../../components/action-menu/ActionMenuItem";
import { getActionMenuItems } from "../../components/action-menu/BaseActions";


 const actionEnums = [
     BaseActionEnum.Export,
     BaseActionEnum.Refresh,
];


export const actions = getActionMenuItems(actionEnums).map(o => {

    if (o.action === BaseActionEnum.Export) {
        if (o.subActions) {
            o.subActions = o.subActions.filter(o => o.action !== BaseActionEnum.PDF )
        }
    }
    return o;
});        

